// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import error from '../../../../common/nodejs/errors';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  TRANS: 'trans',
  TRANS_FAILED: 'transFailed',
  FAILED: 'failed',
  SUCCESS: 'success'
};

export default {
  name: 'requirement046',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      currentMode: '',
      displayInfo: '',
      systemId: '',
      modal_requirement_046: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.TRANS_FAILED:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.TRANS:
        default:
          return 'secondary';
      }
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_requirement_046 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
    },

    /** モード遷移 OKボタン押下 */
    async executeProcess() {
      await this.execute();
    },
    /** OKボタン押下 */
    async exitProcess() {
      // Wizardを閉じる
      this.closeWizard();
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** データ読み出し処理 */
    async read() {
      try {
        this.isLoading = true;
        const token = session.getToken();

        // データ読み出し(要求)（バックエンドAPI_POST）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read'
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // ポーリングが正常に完了した場合
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 取得結果に応じて、ノーマルモード遷移又はチェックモード遷移を表示する
              if (response.data.user_data.value === 'normal') {
                // ■チェックモード遷移
                this.displayInfo = this.i18nWsKey + '.REQ_WS_46_TXT_3';
              } else {
                // ■ノーマルモード遷移
                this.displayInfo = this.i18nWsKey + '.REQ_WS_46_TXT_1';
              }
              this.phase = PHASE.TRANS;
              this.currentMode = response.data.user_data.value;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ルーチン実行処理 */
    async execute() {
      try {
        this.isLoading = true;
        const token = session.getToken();

        // データ読み出し(要求)（バックエンドAPI_POST）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute',
            trans: this.currentMode
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // ポーリングが正常に完了した場合
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              if (this.currentMode === 'normal') {
                this.displayInfo = this.i18nWsKey + '.REQ_WS_46_TXT_4';
              } else {
                this.displayInfo = this.i18nWsKey + '.REQ_WS_46_TXT_2';
              }
              this.phase = PHASE.SUCCESS;
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_EXECUTION_NON_RESPONSE_ERROR:
                  // 無応答であれば遷移失敗
                  // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                  /* eslint-disable max-depth */
                  if (this.currentMode === 'normal') {
                    this.displayInfo = this.i18nWsKey + '.REQ_WS_46_TXT_6';
                  } else {
                    this.displayInfo = this.i18nWsKey + '.REQ_WS_46_TXT_5';
                  }
                  this.phase = PHASE.TRANS_FAILED;
                  break;
                default:
                  this.showUnexpectedError();
                  break;
              }
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** その他エラーの表示 */
    showUnexpectedError() {
      this.phase = PHASE.FAILED;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_046 = false;
    },
  },

  async mounted() {
    this.init();
    // 実行処理
    await this.read();
  },
};